
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";

const Avatar = () => import("vue-avatar");
@Component({ components: { Avatar } })
export default class SendForgotPasswordLinkComponent extends Vue {
  public id = null;
  public userName = null;
  public panNumber = null;
  public phoneNumber = null;
  public otpVal = null
  public linkSent = false;
  public requestforValidate = true;
  public apiValidation = {
    for:null
  };

  public async validateAndSendLink() {
      let result = await this.$validator.validateAll();
      if (result) {
        this.$showLoader(true);
        try{

          const res = await Axios.post(
          API_STORE.AUTHENTICATION + "forgotPassword",
            {
              emailId: this.id,
              subdomain: !!this.$client ? this.$client.subdomain : null,
              url: !!this.$client ? null : window.location.hostname,
              pan: this.panNumber,
              userName: this.userName,
              phone:this.phoneNumber,
              otp: this.requestforValidate ? null : this.otpVal
            }
          );
          this.$showLoader(false);
          if(res.status == 200){
            this.requestforValidate = false;
            if(res.data.token){
              this.$router.push("/forgotPassword/"+res.data.token);
              // this.linkSent = true;
            }
            this.apiValidation = {
              for:null
            }
          }else{
            this.$snotify.error(res.data.mesage);
            this.apiValidation = res.data;
          }

        }catch(e){
          console.log(":::::",e)
        }
      }
  }
}
